export default class EventLibrary {
    events = {};

    constructor(library) {
        this.library = library;
        this.game = library.game;
        this.getLibrary();
    }

    getLibrary = () => {
        this.game.gameApi.getLibrary('Event');
    };

    receiveLibrary = (eventLibrary) => {
        eventLibrary.forEach((eventData) => {
            this.events[eventData.id] = eventData;
        });
    };

}
